import { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

import DocumentViewer from '../../shared/components/visualizador-de-documento/DocumentViewer';

export const VisualizarDocumento: React.FC = () => {
    const [searchParams] = useSearchParams();

    const arquivo = searchParams.get('src');
    const mimeType = searchParams.get('mime') ?? '';

    useEffect(() => {
        document.title = 'Zdoc - Visualizar documento';
    }, []);

    if (!arquivo) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                <Typography variant="h6">Nenhum documento informado para visualização.</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ width: '100%', height: '100vh', bgcolor: 'background.default' }}>
            <DocumentViewer arquivo={arquivo} mimeType={mimeType} width="100%" height="100vh" />
        </Box>
    );
};
